// Resolve a stored location string to a readable city.
//
// App users' locations are stored as raw "lat, lng" coordinates (device
// location); a few are already place names. Coordinates are reverse-geocoded
// via a free, no-key service. Results are cached for the session so a list of
// users at the same coordinates only costs one network call.

const cache = new Map();

export async function coordsToCity(location) {
  if (!location) return '';
  const coords = /^\s*(-?\d{1,3}(?:\.\d+)?)\s*,\s*(-?\d{1,3}(?:\.\d+)?)\s*$/.exec(location);
  if (!coords) return location; // already a place name

  const key = `${coords[1]},${coords[2]}`;
  if (cache.has(key)) return cache.get(key);

  try {
    const res = await fetch(
      `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${coords[1]}&longitude=${coords[2]}&localityLanguage=en`
    );
    const d = await res.json();
    const city = d.city || d.locality || d.principalSubdivision;
    const region = d.principalSubdivision || d.countryName;
    const label = city ? (region && region !== city ? `${city}, ${region}` : city) : location;
    cache.set(key, label);
    return label;
  } catch {
    return location; // fall back to the raw value rather than blanking it
  }
}
